<template>
  <el-dialog :title="'Зөрүү тэмдэглэх'"
    :visible.sync="isShow"
    @close="mCloseFunction"
    @closed="mCloseFunction"
    :before-close="close"
    :close-on-click-modal="isOpenDialog"
    v-if="currentZoruu"
    width="30%"
  >
    <el-form v-model="currentZoruu">
    <el-form-item>
        <el-tag type="info" v-model="currentZoruu.driver_name">Жолооч: {{currentZoruu.driver_name}}</el-tag>
      </el-form-item>
      <el-form-item label="Нийт үйлчилгээний төлбөр" style="margin-bottom: 0px;">
        <el-input
          v-model="currentZoruu.all_salary"
          type="number"
          :rows="5"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item v-if="currentZoruu.settlement_create_deduction > 0" label="Е-баримт суутгал" style="margin-bottom: 0px;">
        <el-input
          v-model="currentZoruu.settlement_create_deduction"
          type="number"
          disabled
          class="deduction"
        ></el-input>
      </el-form-item>
      <el-form-item label="Суутгал хийх боломжтой дүн">
        <el-input
          :value="currentZoruu.all_salary"
          type="number"
          disabled
          class="possible-amount"
        ></el-input>
      </el-form-item>
      <el-form-item label="Дүн">
        <el-checkbox v-model="currentZoruu.is_zoruu_full_amount" @change="isFullAmountChange">Нийт үйлчилгээний төлбөрөөр тооцох</el-checkbox>
        <el-input
          v-if="currentZoruu.is_zoruu_full_amount === true"
          v-model="currentZoruu.all_salary"
          type="number"
          :rows="5"
          disabled
        ></el-input>
        <el-input
          v-else
          v-model.number="currentZoruu.zoruu_salary"
          type="number"
          :rows="5"
          @input="(value) => updateValue(value, currentZoruu.settlement_id)"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="currentZoruu.status_code === 91">
        <el-checkbox v-model="currentZoruu.is_withdraw_salary" :disabled="currentZoruu.is_zoruu_full_amount">Төлбөр буулгах</el-checkbox>
      </el-form-item>
      <el-form-item label="Тайлбар">
        <el-input
          v-model="currentZoruu.zoruu_note"
          type="textarea"
          :rows="5"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="mCloseFunction">Болих</el-button>
      <el-button
        :disabled="isDisable || isDisabled"
        type="success"
        @click="saveDifference"
      >Хадгалах
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getGroups } from '@/utils/auth.js'
export default {
  name: 'SettlementDialog',
  props: {
    isShow: Boolean,
    closeFunction: Function,
    currentZoruu: Object,
    updateValue: Function,
    saveDifference: Function,
    formatDate: Function,
    close: Function,
    isDisabled: Boolean
  },
  data () {
    return {
      isOpenDialog: false,
      group: [],
      isDisable: false
    }
  },
  mounted () {
    this.currentZoruu.salary = this.currentZoruu.all_salary
  },
  created () {
    this.start()
  },
  methods: {
    isFullAmountChange (type) {
      if (type === true) {
        this.currentZoruu.is_withdraw_salary = false
      }
    },
    async start () {
      this.group = await getGroups()
      if (this.group.includes('view')) this.isDisable = true
    },
    mCloseFunction () {
      this.closeFunction()
    }
  }
}
</script>
<style >
.deduction input {
  background-color: #fef0f0 !important;
  border-color: #fde2e2 !important;
  color: #f56c6c !important;
}
.possible-amount input {
  background-color: #fef0f0 !important;
  border-color: #fde2e2 !important;
  color: #409EFF !important;
}
</style>
